import { render, staticRenderFns } from "./allocationprepaid.vue?vue&type=template&id=f4bf3914&"
import script from "./allocationprepaid.vue?vue&type=script&lang=js&"
export * from "./allocationprepaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports